import type { SupabaseClient } from '@supabase/supabase-js'
import { avvAusfertigungLaden, type AvvNachweis } from '../data/supabaseAdapter'
import { sha256Hex } from './avv'
import { dateiSichern } from './dateiSichern'
export function avvZeit(iso: string, de: boolean): string {
  return new Intl.DateTimeFormat(de ? 'de-AT' : 'en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Vienna', timeZoneName: 'short' }).format(new Date(iso))
}
export async function avvHerunterladen(sb: SupabaseClient, tenantId: string, n: AvvNachweis, stillCurrent: () => boolean): Promise<void> {
  if (n.tenant_id !== tenantId || !stillCurrent()) return
  const text = await avvAusfertigungLaden(sb, tenantId, n.id)
  if (!stillCurrent()) return
  if (await sha256Hex(text) !== n.ausfertigung_sha256) throw new Error('avv_hash_abweichend')
  if (!stillCurrent()) return
  await dateiSichern({ stillCurrent, mime: 'text/plain;charset=utf-8', name: `${n.fassung_kennung}-${tenantId}.txt`, bytes: new TextEncoder().encode(text) })
}
